import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import Title from "../../uiKit/Title/Title"
import { gray650, gray900 } from "../../uiKit/assets/colors/colors";
import { getCommunity } from "../../redux/state/communitySlice";

export const Breadcrumb = ({ title }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { communityId } = useParams();

    const community = useSelector(state => state.community.community, shallowEqual);

    useEffect(() => {
        if (!communityId) return;
        dispatch(getCommunity(communityId))
    }, [dispatch, communityId])

    return (
        <div className="breadcrumbWrapper">
            <Title text='Communities' fontWeight={500} color={gray650} onClick={() => history.push('/communities/all')} />
            <Title text='>' fontWeight={500} color={gray650} />
            <Title text={community.name} color={!!title ? gray650 : gray900} fontWeight={500} onClick={() => history.push(`/communities/community/${community.id}`)} />
            {
                !!title && (
                    <>
                        <Title text='>' fontWeight={500} color={gray650} />
                        <Title text={title} fontWeight={500} />
                    </>
                )
            }
        </div>
    )
}
